import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={48} height={48} rx={5.53846} fill={props.bgColor || "#F6F9FF"} />
    <Path
      d="M32.1863 9.68766L11.678 18.0646C10.7513 18.4431 10.3069 19.5013 10.6854 20.428L15.615 32.4964C15.9935 33.4231 17.0517 33.8676 17.9784 33.489L38.4866 25.1121C39.4136 24.7335 39.8578 23.6754 39.4792 22.7486L34.5497 10.6803C34.1714 9.75347 33.1132 9.30903 32.1863 9.68766Z"
      fill={props.color2 || "#CCDFFF"}
    />
    <Path
      d="M32.6257 20.7191L33.3561 22.5073C33.4126 22.6456 33.5704 22.7119 33.7087 22.6554L36.5529 21.4936C36.6913 21.4371 36.7576 21.2793 36.701 21.141L35.9706 19.3528C35.9141 19.2145 35.7564 19.1482 35.618 19.2047L32.7738 20.3665C32.6354 20.423 32.5692 20.5808 32.6257 20.7191Z"
      fill={props.color2 || "#CCDFFF"}
    />
    <Path
      d="M18.5398 23.7275L15.5427 24.9517C15.2909 25.0546 15.0037 24.9338 14.901 24.6822C14.7981 24.4304 14.9187 24.1433 15.1705 24.0404L18.1675 22.8163C18.4193 22.7134 18.7064 22.834 18.8093 23.0858C18.912 23.3373 18.7915 23.6247 18.5398 23.7275Z"
      fill={props.color1 || "#1434CB"}
    />
    <Path
      d="M21.3341 24.5073L16.6405 26.4245C16.2462 26.5856 15.8436 26.5119 15.7408 26.2603C15.638 26.0085 15.8739 25.6743 16.2683 25.5132L20.9619 23.596C21.3562 23.435 21.7587 23.5084 21.8616 23.7602C21.9643 24.0117 21.7285 24.3462 21.3341 24.5073Z"
      fill={props.color1 || "#1434CB"}
    />
    <Path
      d="M29.6562 8.06331C30.6821 7.6443 31.8537 8.13553 32.2725 9.16137L37.202 21.2296C37.621 22.2553 37.129 23.4271 36.103 23.8462L15.5946 32.2233C14.5688 32.6422 13.3978 32.1497 12.9788 31.1239L8.04934 19.0557C7.63044 18.03 8.12208 16.8594 9.14777 16.4403L29.6562 8.06331Z"
      fill={props.color3 || 'white'}
      stroke={props.color2 || "#CCDFFF"}
      strokeWidth={0.387692}
    />
    <Path
      d="M9.09375 21.0938L32.9583 11.3459L34.1425 14.2452L10.278 23.993L9.09375 21.0938Z"
      fill={props?.color2 || "#DDEAFF"}
    />
    <Path
      d="M30.1687 21.2738L30.8991 23.062C30.9556 23.2003 31.1134 23.2666 31.2517 23.2101L34.0959 22.0483C34.2343 21.9918 34.3005 21.834 34.244 21.6957L33.5136 19.9075C33.4571 19.7692 33.2993 19.7029 33.161 19.7594L30.3168 20.9212C30.1784 20.9777 30.1122 21.1354 30.1687 21.2738Z"
      fill={props.color2 || "#CCDFFF"}
    />
    <Path
      d="M16.0827 24.2822L13.0857 25.5064C12.8339 25.6093 12.5467 25.4884 12.4439 25.2369C12.3411 24.9851 12.4617 24.698 12.7135 24.5951L15.7105 23.3709C15.9623 23.2681 16.2494 23.3887 16.3523 23.6405C16.455 23.892 16.3345 24.1794 16.0827 24.2822Z"
      fill={props.color1 || "#1434CB"}
    />
    <Path
      d="M18.8771 25.062L14.1835 26.9792C13.7891 27.1403 13.3865 27.0666 13.2838 26.815C13.1809 26.5632 13.4169 26.229 13.8112 26.0679L18.5049 24.1507C18.8992 23.9896 19.3017 24.0631 19.4046 24.3149C19.5073 24.5664 19.2714 24.9009 18.8771 25.062Z"
      fill={props.color1 || "#1434CB"}
    />
    <Path
      d="M39.3799 22.606L17.2339 22.0458C16.2332 22.0205 15.4014 22.8113 15.376 23.8121L15.0464 36.8442C15.0211 37.8449 15.8119 38.6768 16.8126 38.7021L38.9586 39.2623C39.9596 39.2876 40.7912 38.4968 40.8165 37.4961L41.1462 24.4639C41.1717 23.4632 40.3809 22.6314 39.3799 22.606Z"
      fill={props.color2 || "#CCDFFF"}
    />
    <Path
      d="M37.299 20.7096C38.4068 20.7377 39.2827 21.6579 39.2545 22.7656L38.9248 35.7975C38.8968 36.9052 37.9758 37.781 36.8679 37.753L14.7216 37.1928C13.6139 37.1647 12.7391 36.2436 12.7672 35.1359L13.0968 22.1039C13.1249 20.9963 14.0451 20.1215 15.1527 20.1494L37.299 20.7096Z"
      fill={props.color3 || 'white'}
      stroke={props.color2 || "#CCDFFF"}
      strokeWidth={0.387692}
    />
    <Path
      d="M13.2344 24.3906L39.0047 25.0425L38.9256 28.1733L13.1552 27.5214L13.2344 24.3906Z"
      fill={props?.color2 || "#DDEAFF"}
    />
    <Path
      d="M32.4658 33.0204L32.417 34.9513C32.4132 35.1007 32.5311 35.2247 32.6805 35.2285L35.7518 35.3062C35.9012 35.31 36.0253 35.1921 36.029 35.0427L36.0779 33.1117C36.0817 32.9623 35.9638 32.8383 35.8144 32.8345L32.743 32.7568C32.5936 32.7531 32.4696 32.871 32.4658 33.0204Z"
      fill={props.color2 || "#CCDFFF"}
    />
    <Path
      d="M18.3559 30.1174L15.1195 30.0356C14.8476 30.0287 14.633 29.8027 14.6399 29.5311C14.6468 29.2592 14.8725 29.0446 15.1444 29.0515L18.3808 29.1334C18.6527 29.1403 18.8672 29.366 18.8603 29.6379C18.8535 29.9095 18.6278 30.1243 18.3559 30.1174Z"
      fill={props.color1 || "#1434CB"}
    />
    <Path
      d="M20.6032 31.9599L15.5347 31.8317C15.1089 31.8209 14.7697 31.5918 14.7766 31.3202C14.7835 31.0483 15.1338 30.8368 15.5596 30.8476L20.6281 30.9758C21.0539 30.9866 21.3931 31.2155 21.3862 31.4874C21.3793 31.759 21.029 31.9707 20.6032 31.9599Z"
      fill={props.color1 || "#1434CB"}
    />
  </Svg>
);
export default SVGComponent;
